import { api } from '@services';

import { IEquipmentApiModel } from '@models/Equipment.model';
import { AxiosResponse } from 'axios';
import { Result } from '@utils/index';
import {
  toUniqueFieldsErr,
  UpdateContentError,
} from '@services/queries/customField/updateCustomFieldContent/updateCustomFieldContent';

interface INewCustomField {
  id: string;
  content: any;
}
interface INewEquipment {
  id: string;
  productId?: string | null;
  purchasedPrice?: number | null;
  purchasedFrom?: string | null;
  serial?: string | null;
  sla?: string | null;
  warranty?: Date;
  userId?: string | null;
  // studioId: string; // don't allow it.
  installedSoftwareVersion?: string | null;
  installedFirmwareVersion?: string | null;
  licenseStartDate?: Date | null;
  licenseEndDate?: Date | null;
  purchasedDate?: Date | null;
  extendedWarrantyPurchased?: boolean | null;
  installDate?: Date | null;
  customFields?: INewCustomField[];
  tagsId?: string[];
  equipmentStatusId?: string | null;
}
interface IRequest {
  equipments: INewEquipment[];
}
export interface IPatchEquipmentVariables {
  data: IRequest;
}
type IResponse = AxiosResponse<IEquipmentApiModel[]>;
const patchEquipmentArray = async ({
  data,
}: IPatchEquipmentVariables): Promise<IEquipmentApiModel[]> => {
  const axiosResponse = api.patch<IEquipmentApiModel[]>(
    `/equipments/updateArray`,
    data,
  );

  const result = await Result.asyncCatch<UpdateContentError, IResponse>(
    axiosResponse,
  );

  const result_map = Result.mapErr(result, toUniqueFieldsErr);
  if (result_map.is_ok) {
    const { data: equipments } = result_map.data;
    return equipments;
  }
  throw result_map.error;
};

export { patchEquipmentArray };
